import { FC, cloneElement } from "react";

// Import the styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import useShowFileModal from "@rf-hooks/useShowFileModal";

interface IViewDocumentProps {
  Button: JSX.Element;
  url: string;
  dateMsg?: string;
}

const ViewDocument: FC<IViewDocumentProps> = props => {
  const { showFileModal } = useShowFileModal();
  return cloneElement(props.Button, {
    onClick: () =>
      showFileModal({
        url: props.url,
        dateMsg: props.dateMsg
      })
  });
};

export default ViewDocument;
